export default __webpack_public_path__ + "static/illustration-content.url-dafdc30b4db8a835e557676f40301b1a.svg";